import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

type LineConfig = {
  dataKey: string;
  name: string;
  stroke?: string;
}

type ReusableLineChartProps<T> = {
  data: T[];
  label: string;
  xAxisKey: keyof T;
  lines: LineConfig[];
  height?: number;
};

export function LinesChart<T extends object>({
  data,
  label,
  xAxisKey,
  lines,
  height
}: ReusableLineChartProps<T>) {
  return (
    <div>
      <h3 style={{ textAlign: "center", marginTop: 0, marginBottom: 18, height: 28 }}>{label}</h3>
      <ResponsiveContainer width={"99%"} height={height}>
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xAxisKey as string} />
          <YAxis />
          <Tooltip />
          <Legend />
          {lines.map((line) => (
            <Line
              key={line.dataKey}
              type="monotone"
              dataKey={line.dataKey}
              name={line.name}
              stroke={line.stroke}
              strokeWidth={2}
              dot={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LinesChart;